import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import axios from 'axios';
import { getApiUrl } from '../../../utils/apiConfig';


const ComercialDropDown = ({ selectedVisita, setSelectedVisita, user, comercialIdsPermitidos }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [comercialOptions, setComercialOptions] = useState([]);

  useEffect(() => {
    const fetchComerciales = async () => {
      try {
        const response = await axios.get(getApiUrl('/api/comerciales'), { withCredentials: true });
        const data = response.data.map(c => ({
          value: c.Comercial,
          id: c.IdComercial, // Usar el IdComercial completo
          label: `${c.Comercial} | ${c.IdComercial}`,
          color: '#eee'
        }));
        const filteredData = comercialIdsPermitidos.length === 0
          ? data
          : data.filter(c => comercialIdsPermitidos.includes(String(c.id).trim()));
        setComercialOptions(filteredData);
        // setComercialOptions(data);


        // Solo asignar comercial si NO tiene ninguno seleccionado
        if (!selectedVisita?.Comercial || !selectedVisita?.IdComercial) {
          const userComercial = data.find(
            c =>
              c?.value?.toUpperCase() === user?.name?.toUpperCase() ||
              String(c?.id) === String(user?.id)
          );
          if (userComercial) {
            setSelectedVisita({ ...selectedVisita, Comercial: userComercial.value, IdComercial: userComercial.id });
          } else if (filteredData.length > 0) {
            setSelectedVisita({ ...selectedVisita, Comercial: filteredData[0].value, IdComercial: filteredData[0].id });
          }
        }

      } catch (err) {
        console.error('Error al cargar comerciales:', err);
      }
    };

    fetchComerciales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const selected = comercialOptions.find(opt => opt.value === selectedVisita?.Comercial) || { value: '', label: '', color: '#eee' };

  
  const selected = {
    value: selectedVisita?.Comercial || '',
    label: selectedVisita?.Comercial || '',
    color: '#eee'
  };

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Comercial*</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="DropDownName w-full shadow-sm p-2 border rounded bg-white text-left flex justify-between items-center"
      >
        <span className='truncate'>
          {selectedVisita.Comercial} | {selectedVisita.IdComercial}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto">
          {comercialOptions.map((option) => {
            return (
              <li
                key={option.id}
                onClick={() => {
                  setSelectedVisita({
                    ...selectedVisita,
                    Comercial: option.value,
                    IdComercial: option.id, // Usar el IdComercial completo
                  });
                  setIsOpen(false);
                }}
                className={classNames('cursor-pointer px-4 py-2 text-sm', {
                  'bg-gray-100': selectedVisita.Comercial === option.value,
                })}
                style={{ backgroundColor: selectedVisita.Comercial === option.value ? '#f3f4f6' : 'white' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = option.color)}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = selectedVisita.Comercial === option.value ? '#f3f4f6' : 'white')}
              >
                {option.value} <span className="text-gray-400">| {option.id}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ComercialDropDown;
